import PropTypes from 'prop-types';
import {createSelector} from 'reselect';

import {connect} from '@stubhub/react-store-provider';

const DeviceToggle = ({on = [], deviceType, children, and = true, or = false}) => {
  /**
   * If Single String value for on is passed convert it to Array for Processing Uniformity
   *
   */
  if (typeof on === 'string') {
    on = [on];
  }

  /**
   * Returns Children if
   * 1) `on` prop is an empty Array i.e. No deviceTypes have been provided.
   * 2) `or` prop passed has evaluated to true.
   * 3) `on` prop has the current device type and `and` prop condition is evaluated to true.
   *
   * Returns Null if
   * 1) `on` prop does not have the current device type
   * 2) `and` prop condition is evaluated to false.
   *
   */
  return !on.length || or || (and && on.indexOf(deviceType) !== -1) ? children : null;
};

DeviceToggle.propTypes = {
  /**
   * The Types of Devices for which the Children have to be rendered.
   *
   */
  on: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /**
   * The Current Device Type Detected by the Server.
   *
   */
  deviceType: PropTypes.string,

  /**
   * Additional Condition that needs to true for the Children to be Render
   *
   */
  and: PropTypes.bool,

  /**
   * Alternate Condition if true will SUPERSEDE all other conditions for the Children to be Render
   *
   */
  or: PropTypes.bool,
  children: PropTypes.node,
};

/* istanbul ignore next */
const deviceTypeSelector = createSelector(
  (state = {}) => state.device,
  (device = {}) => device.type
); // Ignore defensive variable declaration

function mapStateToProps(state) {
  return {
    deviceType: deviceTypeSelector(state),
  };
}

export default connect({mapStateToProps})(DeviceToggle);
export * from './device-types';
